import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    :root {
     --background: #cbe1ff;
     --rose: #fbcfdd;
     --white: #ffffff;
    }
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        @media (max-width: 1080px) {
            font-size: 93.75%;
        }
        @media (max-width: 720px) {
            font-size: 87.5%;
        }
    }

    /* html, body, #root {
        min-height: 100%;
        width: 100%;
        overflow-x: hidden;
    } */

    body {
        background: var(--background);
        -webkit-font-smoothing: antialiased;
        
        ::-webkit-scrollbar {
            width: 10px;
        }

        ::-webkit-scrollbar-track {
            background-color: #58626c;
        }

        ::-webkit-scrollbar-thumb {
            background-color: #87868b;
            border-radius: 20px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
            background-color: #696969;
        }
    }


    body, input, textarea, button {
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
    }

    ul {
        list-style: none;
    }

    button {
        cursor: pointer;
    }

    [disabled] {
        opacity: 0.6;
        cursor: not-allowed;
    }

    img.division {
       margin: 0 auto;
       display: block;
       width: 150;
    }

    .rhap_play-pause-button {
        font-size: 35px;
        width: 28px;
        height: 40px;
    }

    .rhap_main-controls-button {
        margin: 0;
        color: #868686;
        font-size: 30px;
        height: 35px;
    }
    .rhap_container {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        line-height: 1;
        font-family: inherit;
        width: 100%;
        padding: 0;
        background-color: #dcdcdc;
        box-shadow: 0 0 3px 0 rgb(0 0 0 / 20%);
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
`